<template class="full-heigth">
  <div class="full-heigth" style="padding: 15px">
    <el-form :inline="true" class="filter-form" style="display: flex" @submit.native.prevent>
      <el-form-item label="查詢">
        <el-input
          v-model="listQuery.search.query"
          placeholder="請輸入場次代號 / 場次名稱"
          style="width: 280px"
          @keyup.enter.native="handleSearch"
        />
      </el-form-item>
      <div style="margin: 8px 0 0 8px">
        <el-button
          type="primary"
          icon="el-icon-search"
          circle
          @click="handleSearch"
          :loading="loading"
        ></el-button>
        <el-button
          type="success"
          icon="el-icon-refresh-left"
          circle
          @click="handleRefresh"
          :loading="loading"
        ></el-button>
        <el-button
          type="warning"
          icon="el-icon-plus"
          circle
          @click="handleCreate"
          :loading="loading"
        ></el-button>
      </div>
    </el-form>

    <div style="position: relative; height: 80%">
      <el-table
        v-loading="loading"
        size="mini"
        :data="gameList"
        border
        fit
        highlight-current-row
        height="calc(80vh - 180px)"
        overflow-x="auto"
      >
        <el-table-column align="center" label="項次" width="60">
          <template slot-scope="scope">
            <span>{{ (listQuery.page - 1) * listQuery.limit + scope.$index + 1 }}</span>
          </template>
        </el-table-column>

        <el-table-column align="center" label="場次代號" min-width="120">
          <template slot-scope="scope">
            <span>{{ scope.row.code }}</span>
          </template>
        </el-table-column>

        <el-table-column align="left" label="場次名稱" min-width="160">
          <template slot-scope="scope">
            <span>{{ scope.row.name }}</span>
          </template>
        </el-table-column>

        <el-table-column align="center" label="設定網址" min-width="140">
          <template slot-scope="scope">
            <el-button
              v-if="scope.row.editorUrl"
              size="mini"
              type="primary"
              @click="handleCopyLink(scope.row.editorUrl, $event)"
            >
              複製網址 <i class="el-icon-copy-document"></i>
            </el-button>
          </template>
        </el-table-column>

        <el-table-column align="center" label="遊玩網址" min-width="140">
          <template slot-scope="scope">
            <el-button
              v-if="scope.row.playerUrl"
              size="mini"
              type="success"
              @click="handleCopyLink(scope.row.playerUrl, $event)"
            >
              複製網址 <i class="el-icon-copy-document"></i>
            </el-button>
          </template>
        </el-table-column>

        <el-table-column align="center" label="建立時間" min-width="180">
          <template slot-scope="scope">
            <span>{{ scope.row.createTime }}</span>
          </template>
        </el-table-column>

        <el-table-column align="center" label="操作" width="160">
          <template slot-scope="scope">
            <el-button type="primary" size="mini" @click="handleEdit(scope.row)">編輯</el-button>
            <el-button type="danger" size="mini" @click="handleDelete(scope.row)">刪除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <pagination
        v-show="listQuery.total > 0"
        layout="prev, pager, next"
        :total="listQuery.total"
        :page.sync="listQuery.page"
        :limit.sync="listQuery.limit"
        @pagination="handlePagination"
      />
    </div>

    <el-dialog
      :title="dialogForm.id ? '編輯場次' : '建立場次'"
      :visible.sync="dialogVisible"
      width="500px"
      @closed="handleDialogClose"
    >
      <el-form :model="dialogForm" ref="dialogForm" label-width="100px" size="small">
        <el-form-item
          label="場次代號"
          prop="code"
          :rules="[{ required: true, message: '請輸入場次代號', trigger: 'blur' }]"
        >
          <el-input
            v-model="dialogForm.code"
            placeholder="請輸入場次代號"
            :disabled="dialogForm.id"
          />
        </el-form-item>

        <el-form-item
          label="場次名稱"
          prop="name"
          :rules="[{ required: true, message: '請輸入場次名稱', trigger: 'blur' }]"
        >
          <el-input v-model="dialogForm.name" placeholder="請輸入場次名稱" />
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="dialogVisible = false">取消</el-button>
        <el-button size="small" type="primary" :loading="submitLoading" @click="handleDialogSave">
          確定
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Pagination from '@/components/Pagination'
import checkPermission from '@/utils/permission'
import clipboard from '@/utils/clipboard'
import { getAgencyOptions } from '@/api/agency'
import { getItaGameForPaged, saveItaGame, deleteItaGame } from '@/api/ita'

export default {
  name: 'ItaGamesManagement',
  components: {
    Pagination,
  },
  data() {
    return {
      agencyCode:
        this.$store.getters.userInfo && this.$store.getters.userInfo.agencyCode
          ? this.$store.getters.userInfo.agencyCode
          : null,
      loading: false,
      submitLoading: false,
      gameList: [],
      dialogVisible: false,
      dialogForm: {
        id: null,
        code: '',
        name: '',
      },
      listQuery: {
        search: {
          query: '',
        },
        page: 1,
        limit: 10,
        total: 0,
      },
      agencyList: [],
      isAdmin: checkPermission(['ITA-DEV', 'APP-ADMIN', 'ITA-ADMIN']),
    }
  },
  async created() {
    await this.getAgencyOptions()
    await this.getGamesList()
  },
  watch: {
    async loading(newValue) {
      if (newValue) {
        try {
          await this.$store.dispatch('app/showDownloadLoading', true)
          await this.$store.dispatch('app/showDownloadLoadingText', '資料處理中，請稍後')
        } catch (error) {
          console.error('Loading 初始化失敗:', error)
          await this.$store.dispatch('app/showDownloadLoading', false)
        }
      } else {
        await this.$store.dispatch('app/showDownloadLoading', false)
      }
    },
    async agencyCode() {
      this.listQuery.page = 1
      await this.getGamesList()
    },
  },
  methods: {
    // 複製連結
    handleCopyLink(text, event) {
      clipboard(text, event)
    },
    // 搜尋
    async handleSearch() {
      this.listQuery.page = 1
      await this.getGamesList()
    },
    // 重置查詢
    async handleRefresh() {
      this.listQuery = {
        search: { query: '' },
        page: 1,
        limit: 10,
        total: 0,
      }
      await this.getGamesList()
    },
    // 分頁切換
    async handlePagination() {
      await this.getGamesList()
    },
    // 打開新增彈窗
    handleCreate() {
      this.dialogForm = {
        id: null,
        code: '',
        name: '',
      }
      this.dialogVisible = true
      this.$nextTick(() => {
        if (this.$refs.dialogForm) {
          this.$refs.dialogForm.clearValidate()
        }
      })
    },
    // 打開編輯彈窗
    handleEdit(data) {
      this.dialogForm = {
        id: data.id || null,
        code: data.code || '',
        name: data.name || '',
      }
      this.dialogVisible = true
      this.$nextTick(() => {
        if (this.$refs.dialogForm) {
          this.$refs.dialogForm.clearValidate()
        }
      })
    },
    // 儲存 (新增 / 編輯)
    handleDialogSave() {
      this.$refs.dialogForm.validate(async valid => {
        if (!valid) return

        this.submitLoading = true
        const payload = {
          ...this.dialogForm,
          agencyCode: this.agencyCode,
        }

        try {
          await saveItaGame(payload)
          this.$message.success(this.dialogForm.id ? '修改成功' : '新增成功')
          this.dialogVisible = false
          await this.getGamesList()
        } catch (err) {
          console.error(err)
          this.$message.error('儲存失敗')
        } finally {
          this.submitLoading = false
        }
      })
    },
    // 關閉對話框清理
    handleDialogClose() {
      this.dialogForm = { id: null, code: '', name: '' }
      if (this.$refs.dialogForm) {
        this.$refs.dialogForm.resetFields()
      }
    },
    // 刪除
    async handleDelete(data) {
      try {
        await this.$confirm('確定要刪除這筆資料嗎?', '警告', {
          confirmButtonText: '確定',
          cancelButtonText: '取消',
          type: 'warning',
        })

        this.loading = true
        await deleteItaGame(data)
        this.$message.success('刪除成功')
        await this.getGamesList()
      } catch (err) {
        if (err !== 'cancel') {
          console.error(err)
          this.$message.error('刪除失敗')
        }
      } finally {
        this.loading = false
      }
    },
    // 取得資料列表
    async getGamesList() {
      this.loading = true
      try {
        const res = await getItaGameForPaged({
          ...this.listQuery,
        })

        if (res.success && res.data) {
          this.gameList = res.data.data || []
          this.listQuery.total = res.data.total || 0
        } else if (Array.isArray(res.data)) {
          // 兼容 response 回傳陣列結構
          this.gameList = res.data
          this.listQuery.total = res.total || res.data.length
        }
      } catch (err) {
        console.error(err)
      } finally {
        this.loading = false
      }
    },
    // 取得旅行社選單
    async getAgencyOptions() {
      try {
        const response = await getAgencyOptions()
        this.agencyList = response.data || []
      } catch (err) {
        console.error(err)
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.agency-select-item {
  ::v-deep .el-form-item__content {
    width: 100%;
  }
}
</style>
